<template>
  <b-modal
      id="managementInventoryModal"
      ref="managementInventoryModal"
      title="Atualização de status do item"
      ok-title="Atualizar"
      close-title="Fechar"
      size="sm"
      no-close-on-esc
      no-close-on-backdrop
      v-model="inventoryModalShow"
  >
    <form @submit.stop.prevent="onUpdatedStatus">
      <input
          type="text"
          class="form-control display-hidden"
          v-model="invoiceVolumeId"
          disabled
      />
      <b-row class="pb-1">
        <b-col>
          <multiselect
          v-model="itemInventoryStatusButton"
          track-by="value"
          label="label"
          id="itemInventoryStatus"
          placeholder="Selecionar status"
          :options="options.itemInventoryStatus"
          :hide-selected="false"
          />
          <b-form-feedback
              v-text="formRequest.errors.get('status')"
              v-if="formRequest.errors.has('status')">
          </b-form-feedback>
        </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
            <div class="float-left">
                <spinner v-if="loadingData" message="Processando..."></spinner>
            </div>
            <div class="float-right">
                <b-btn @click="inventoryModalShow = false" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn @click="onUpdatedStatus" variant="secondary">
                  Atualizar
                </b-btn>
            </div>
        </div>
  </b-modal>
</template>

<script>
import {ManagementStatusEnum} from "../enums/GeneralEnums";

export default {
  data() {
    return {
      inventoryModalShow: false,
      itemInventoryStatus: "",
      invoiceVolumeId: "",
      loading: false,
      options: {
        itemInventoryStatus: this.getAllItemStatus(),
      },
      formRequest: new Form({
        status: "",
        volume_ids: [],
      })
    };
  },
  methods: {
    onCreate(data) {
      data.doc_fiscal_volume_bip.map(item => this.formRequest.volume_ids.push(item.docfisvol_id));
      this.$refs.managementInventoryModal.show();
    },
    getAllItemStatus() {
      return [
        {label: "Em negociação", value: ManagementStatusEnum.IN_NEGOTIATION},
        {label: "Vendido", value: ManagementStatusEnum.SOLD},
        {label: "Coletado", value: ManagementStatusEnum.COLLECTED},
      ];
    },
    onUpdatedStatus() {
      this.formRequest.status = this.itemInventoryStatus.value;
      this.loading = true;
      this.formRequest.patch(`/api/inventario/gestao/volumes/status`)
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            this.$emit('refreshTable');
            this.inventoryModalShow = false;
            this.formRequest.volume_ids = [];
          })
          .catch((error) => {
            new ReturnApi(error, this, true, false, false);
            this.loadingData = false;
          });
    },
  },
  computed: {
    itemInventoryStatusButton: {
      get() {
        return this.itemInventoryStatus || []
      },
      set(value) {
        this.itemInventoryStatus = value || []
      }
    },
  }
};
</script>
